/* Tiroir panier Whoosh : portage sans framework de src/template/panier/TiroirPanier.tsx
   (maquette), branché sur le vrai panier Shopify (API Ajax : /cart.js, /cart/add.js,
   /cart/change.js, /cart/update.js).

   Même balisage, mêmes classes, mêmes états et mêmes effets que la maquette :
   - ordinateur : panneau à droite ; téléphone : feuille qui monte du bas (CSS de la maquette) ;
   - page figée pendant l'ouverture (méthode Safari iPhone), Échap ferme, focus dans le panneau ;
   - bandeau « panier réservé » avec minuteur de 10 minutes relancé à l'échéance (cookie timerCart) ;
   - confirmation d'ajout (3,2 s) et couette ajoutée allumée en rose ;
   - barre de paliers, une seule proposition en photo, total, Klarna, garanties.

   Le rendu passe par une petite réconciliation, comme React : les éléments déjà présents
   sont mis à jour sur place, pour que les transitions CSS jouent comme sur la maquette
   (remplissage de la barre, paliers, apparition décalée des blocs).

   Événements (contrat de la maquette) :
   - écoute `tpl-panier:ajouter` (detail.items = [{ id, quantity, properties }]) et `tpl-panier:ouvrir` ;
   - publie `tpl-panier:compte` (detail = nombre d'articles) et `tpl:fige` ({ actif, y }).

   Packs : les lignes Shopify qui portent la même propriété `_pack_id` forment une seule
   ligne visuelle « Duo enfants · Rose poudré + Bleu ciel », au prix de la somme de leurs
   final_line_price ; sa quantité se change et se supprime d'un bloc. */
(function () {
  "use strict";

  var SVG = "http://www.w3.org/2000/svg";
  var TRAITS = {
    fermer: "M6 6l12 12M18 6L6 18",
    moins: "M6 12h12",
    plus: "M12 6v12M6 12h12",
    corbeille: "M5 7h14M10 7V5h4v2M7 7l1 12h8l1-12",
    coche: "M5 12.5l4.2 4.2L19 7",
    cadenas: "M7 11V8a5 5 0 0 1 10 0v3M5.5 11h13v9h-13z",
    colis: "M3.5 7.5L12 3l8.5 4.5v9L12 21l-8.5-4.5zM3.5 7.5L12 12l8.5-4.5M12 12v9",
    horloge: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7.5V12l3 2",
    cadeau: "M4 10h16v10H4zM3 7h18v3H3zM12 7v13M12 7c-1.5-3-5-3-5-.8C7 7 12 7 12 7zm0 0c1.5-3 5-3 5-.8C17 7 12 7 12 7z",
  };
  /* Composition des packs ajoutés depuis cet appareil : ordre des coloris choisis,
     quantité de chaque variante dans un pack et fiche d'origine. */
  var CLE_PACKS = "wh-panier-packs";
  var MAX = 9;

  var deux = function (n) {
    return String(n).padStart(2, "0");
  };
  /* Même format que la maquette : « 119,00 € », « 1 290,00 € ». */
  var euros = function (cents) {
    var v = Math.round(Number(cents) || 0) / 100;
    return v.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
  };

  /* --- Construction d'éléments ------------------------------------------------ */
  function h(tag, attrs, enfants) {
    var el = tag === "svg" || tag === "path" ? document.createElementNS(SVG, tag) : document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        var v = attrs[k];
        if (v == null || v === false) continue;
        if (k === "cle") el._cle = v;
        else if (k === "act") el._act = v;
        else el.setAttribute(k, v === true ? "" : String(v));
      }
    }
    (enfants || []).forEach(function (c) {
      if (c == null || c === false) return;
      el.appendChild(typeof c === "object" ? c : document.createTextNode(String(c)));
    });
    return el;
  }

  function icone(nom) {
    return h("svg", { viewBox: "0 0 24 24", width: "18", height: "18", "aria-hidden": "true", focusable: "false" }, [
      h("path", {
        d: TRAITS[nom],
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "1.7",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
      }),
    ]);
  }

  /* --- Réconciliation (comme React : par clé, sinon par position et par type) --- */
  function pareil(a, b) {
    return a.nodeType === b.nodeType && (a.nodeType !== 1 || a.nodeName === b.nodeName) && a._cle === b._cle;
  }

  function accorder(ancien, neuf) {
    if (ancien.nodeType !== 1) {
      if (ancien.nodeValue !== neuf.nodeValue) ancien.nodeValue = neuf.nodeValue;
      return;
    }
    var i, a;
    for (i = ancien.attributes.length - 1; i >= 0; i--) {
      a = ancien.attributes[i];
      if (!neuf.hasAttribute(a.name)) ancien.removeAttribute(a.name);
    }
    for (i = 0; i < neuf.attributes.length; i++) {
      a = neuf.attributes[i];
      if (ancien.getAttribute(a.name) !== a.value) ancien.setAttribute(a.name, a.value);
    }
    ancien._act = neuf._act;
    accorderEnfants(ancien, neuf);
  }

  function accorderEnfants(parent, modele) {
    var anciens = Array.prototype.slice.call(parent.childNodes);
    var neufs = Array.prototype.slice.call(modele.childNodes);
    var parCle = {};
    var libres = [];
    anciens.forEach(function (n) {
      if (n._cle != null) parCle[n._cle] = n;
      else libres.push(n);
    });
    var j = 0;
    var garde = neufs.map(function (n) {
      var m = null;
      if (n._cle != null) {
        var o = parCle[n._cle];
        if (o && pareil(o, n)) {
          m = o;
          delete parCle[n._cle];
        }
      } else if (j < libres.length) {
        var o2 = libres[j++];
        if (pareil(o2, n)) m = o2;
      }
      if (m) accorder(m, n);
      return m || n;
    });
    anciens.forEach(function (n) {
      if (garde.indexOf(n) < 0 && n.parentNode === parent) parent.removeChild(n);
    });
    garde.forEach(function (n, i) {
      var ici = parent.childNodes[i];
      if (ici !== n) parent.insertBefore(n, ici || null);
    });
  }

  /* --- Outils ------------------------------------------------------------------ */
  function lireJSON(cle) {
    try {
      return JSON.parse(localStorage.getItem(cle) || "null");
    } catch (e) {
      return null;
    }
  }
  function ecrireJSON(cle, valeur) {
    try {
      localStorage.setItem(cle, JSON.stringify(valeur));
    } catch (e) {}
  }
  function taille(handle) {
    var m = /(\d{3})x(\d{3})/.exec(handle || "");
    return m ? m[1] + "x" + m[2] : "";
  }
  function pgcd(a, b) {
    return b ? pgcd(b, a % b) : a;
  }

  /* --- Tiroir -------------------------------------------------------------------- */
  function creer(racine, D) {
    var T = D.textes || {};
    var catalogue = D.catalogue || {};
    var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var panneau = racine.querySelector(".wp-panneau");
    var voile = racine.querySelector(".wp-voile");
    var videModele = racine.querySelector(".wp-vide");
    videModele = videModele ? videModele.cloneNode(true) : null;

    /* Clés des blocs rendus côté serveur, pour la réconciliation. */
    var poignee = panneau.querySelector(".wp-poignee");
    if (poignee) poignee._cle = "poignee";
    var tete = panneau.querySelector(".wp-tete");
    if (tete) tete._cle = "tete";
    var vide = panneau.querySelector(".wp-vide");
    if (vide) vide._cle = "vide";

    var panier = D.panier || { items: [], item_count: 0, total_price: 0 };
    var ouvert = false;
    var ajoute = null; // { cle, t } : dernier article ajouté
    var minuterieAjout = 0;
    var choix = { cle: null, i: 0 }; // coloris choisi dans la proposition
    var optimiste = {}; // quantités affichées avant la réponse de Shopify
    var comparer = {}; // prix barrés trouvés hors catalogue, par variante
    var demandes = {};
    var fige = null;
    var minuteur = 0;
    var echeance = 0;
    var reste = "";
    var file = Promise.resolve();
    var nbPublie = null;
    var vu = null;

    /* -- Réseau ---------------------------------------------------------------- */
    function requete(chemin, corps) {
      var init = { headers: { Accept: "application/json" }, credentials: "same-origin" };
      if (corps) {
        init.method = "POST";
        init.headers["Content-Type"] = "application/json";
        init.body = JSON.stringify(corps);
      }
      return fetch(route + chemin, init).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw j;
          return j;
        });
      });
    }
    function enFile(fn) {
      file = file.then(fn).catch(function (e) {
        if (window.console) console.warn("Panier Whoosh :", e);
      });
      return file;
    }
    function recevoir(json) {
      if (json && json.items) panier = json;
    }
    function charger() {
      return requete("cart.js").then(recevoir);
    }

    /* Prix barré d'une variante absente du catalogue de la section : lu sur la fiche. */
    function chercherComparer(handle) {
      if (!handle || demandes[handle]) return;
      demandes[handle] = 1;
      requete("products/" + handle + ".js")
        .then(function (p) {
          (p.variants || []).forEach(function (v) {
            comparer[v.id] = v.compare_at_price || 0;
          });
          rendre();
        })
        .catch(function () {});
    }

    /* -- Packs ajoutés depuis cet appareil -------------------------------------- */
    function packs() {
      return lireJSON(CLE_PACKS) || {};
    }
    function memoriserPacks(items) {
      var page = /\/products\/([^/?#]+)/.exec(location.pathname);
      var m = packs();
      var neuf = false;
      items.forEach(function (it) {
        var id = it.properties && it.properties._pack_id;
        if (!id) return;
        var p = m[id] || (m[id] = { ordre: [], base: {}, source: page ? decodeURIComponent(page[1]) : null });
        var q = Math.max(1, Number(it.quantity) || 1);
        for (var k = 0; k < q; k++) p.ordre.push(Number(it.id));
        p.base[it.id] = (p.base[it.id] || 0) + q;
        neuf = true;
      });
      if (neuf) ecrireJSON(CLE_PACKS, m);
    }
    function nettoyerPacks() {
      var m = packs();
      var presents = {};
      (panier.items || []).forEach(function (it) {
        if (it.properties && it.properties._pack_id) presents[it.properties._pack_id] = 1;
      });
      var change = false;
      for (var id in m) {
        if (!presents[id]) {
          delete m[id];
          change = true;
        }
      }
      if (change) ecrireJSON(CLE_PACKS, m);
    }

    /* -- Lignes visuelles ----------------------------------------------------- */
    function fiche(it) {
      return catalogue[it.handle] || {};
    }
    function tailleDe(it) {
      return fiche(it).taille || taille(it.handle);
    }
    function lienDe(it) {
      return fiche(it).url || String(it.url || "").split("?")[0];
    }
    function imageDe(it) {
      var f = fiche(it);
      return f.image || (it.featured_image && it.featured_image.url) || it.image || "";
    }
    function colorisDe(it) {
      var f = fiche(it);
      return f.coloris || (it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : it.product_title);
    }
    function barreUnitaire(it) {
      var f = fiche(it);
      if (f.id === it.variant_id || f.id === it.id) return f.barre || 0;
      if (comparer[it.variant_id] == null) chercherComparer(it.handle);
      return comparer[it.variant_id] || 0;
    }

    function lignes() {
      /* Shopify range l'article le plus récent en premier : la maquette l'ajoute à la fin. */
      var items = (panier.items || []).slice().reverse();
      var groupes = {};
      var liste = [];
      items.forEach(function (it) {
        var pid = it.properties && it.properties._pack_id;
        if (pid) {
          var g = groupes[pid];
          if (!g) {
            g = groupes[pid] = { cle: "pack:" + pid, id: pid, pack: it.properties._pack || "", items: [] };
            liste.push(g);
          }
          g.items.push(it);
        } else {
          liste.push({ cle: it.key, items: [it] });
        }
      });
      var memo = packs();
      return liste.map(function (g) {
        return g.id ? lignePack(g, memo[g.id]) : ligneSimple(g);
      });
    }

    function ligneSimple(g) {
      var it = g.items[0];
      var t = tailleDe(it);
      var barre = barreUnitaire(it) * it.quantity;
      return {
        cle: g.cle,
        items: g.items,
        nom: it.product_title,
        variante: (it.properties && it.properties._variante) || (t ? t + " cm" : it.variant_title || ""),
        quantite: it.quantity,
        prix: it.final_line_price,
        barre: barre > it.final_line_price ? barre : 0,
        image: imageDe(it),
        lien: lienDe(it),
      };
    }

    function lignePack(g, memo) {
      var items = g.items;
      var parId = {};
      items.forEach(function (it) {
        parId[it.variant_id] = it;
      });
      /* Nombre de packs : composition mémorisée à l'ajout, sinon 2 couettes enfant par pack. */
      var q = 0;
      if (memo && memo.base) {
        items.forEach(function (it) {
          var b = memo.base[it.variant_id];
          if (b) q = Math.max(q, Math.round(it.quantity / b));
        });
      }
      if (!q) {
        var enfants = 0;
        items.forEach(function (it) {
          if (tailleDe(it) === "150x200") enfants += it.quantity;
        });
        q = enfants >= 2 ? Math.floor(enfants / 2) : items.reduce(function (a, it) { return pgcd(a, it.quantity); }, 0);
      }
      q = Math.max(1, q);
      var base = {};
      items.forEach(function (it) {
        base[it.variant_id] = (memo && memo.base && memo.base[it.variant_id]) || Math.max(1, Math.round(it.quantity / q));
      });
      /* Coloris dans l'ordre choisi sur la fiche. */
      var noms = [];
      if (memo && memo.ordre && memo.ordre.every(function (id) { return parId[id]; })) {
        memo.ordre.forEach(function (id) {
          noms.push(colorisDe(parId[id]));
        });
      } else {
        items.forEach(function (it) {
          for (var k = 0; k < base[it.variant_id]; k++) noms.push(colorisDe(it));
        });
      }
      var source = null;
      if (memo) {
        items.forEach(function (it) {
          if (!source && memo.source && it.handle === memo.source) source = it;
        });
        if (!source && memo.ordre && memo.ordre.length) source = parId[memo.ordre[0]];
      }
      source = source || items[0];
      var prix = 0;
      var barre = 0;
      items.forEach(function (it) {
        prix += it.final_line_price;
        barre += it.original_line_price;
      });
      return {
        cle: g.cle,
        items: items,
        pack: true,
        base: base,
        nom: source.product_title,
        variante: (g.pack || "") + (noms.length ? " · " + noms.join(" + ") : ""),
        quantite: q,
        prix: prix,
        barre: barre > prix ? barre : 0,
        image: imageDe(source),
        lien: lienDe(source),
      };
    }

    function vue() {
      var ls = lignes().filter(function (l) {
        if (optimiste[l.cle] == null) return true;
        l.quantite = optimiste[l.cle];
        return l.quantite > 0;
      });
      var nb = ls.reduce(function (s, l) {
        return s + l.quantite;
      }, 0);
      var enfants = 0;
      var adulte = false;
      (panier.items || []).forEach(function (it) {
        var t = tailleDe(it);
        if (t === "150x200") enfants += it.quantity;
        if (t === "230x230") adulte = true;
      });
      var enfantSeule = ls.some(function (l) {
        return !l.pack && tailleDe(l.items[0]) === "150x200";
      });
      /* Paliers : livraison offerte dès la 1re couette, -19,90 € dès la 2e couette enfant
         (la remise automatique de Shopify s'applique à partir de 2 couettes 150x200). */
      var duo = enfants >= 2;
      var remises = (panier.cart_level_discount_applications || []).filter(function (r) {
        return r.total_allocated_amount > 0;
      });
      var economie = ls.reduce(function (s, l) {
        return s + (l.barre ? l.barre - l.prix : 0);
      }, 0);
      remises.forEach(function (r) {
        economie += r.total_allocated_amount;
      });
      /* Une seule proposition, la plus utile pour ce panier. */
      var P = D.propositions || [];
      var proposition = null;
      if (enfantSeule && !duo) proposition = P[0];
      else if (!adulte && nb > 0) proposition = P[1];
      if (proposition) {
        var coloris = (proposition.handles || [])
          .map(function (hd) {
            var f = catalogue[hd];
            return f && f.id ? f : null;
          })
          .filter(Boolean);
        proposition = coloris.length ? { p: proposition, coloris: coloris } : null;
      }
      return {
        lignes: ls,
        nb: nb,
        total: panier.total_price || 0,
        economie: economie,
        remises: remises,
        duo: duo,
        message: duo ? T.debloque : enfants > 0 ? T.enfant : T.adulte,
        proposition: proposition,
      };
    }

    /* -- Rendu ---------------------------------------------------------------- */
    function rendre() {
      var v = (vu = vue());
      var enfants = [
        h("span", { class: "wp-poignee", "aria-hidden": "true", cle: "poignee" }),
        v.nb ? reservation() : null,
        entete(v),
        confirmation(v),
      ];
      if (v.nb) enfants.push(corps(v), pied(v));
      else if (videModele) {
        var c = videModele.cloneNode(true);
        c._cle = "vide";
        enfants.push(c);
      }
      accorderEnfants(panneau, h("div", null, enfants));
      publierCompte(v.nb);
      majMinuteur();
    }

    function reservation() {
      var min = Number(D.minutes) || 10;
      return h("p", { class: "wp-reserve", role: "timer", "aria-live": "off", cle: "reserve" }, [
        icone("horloge"),
        (T.reservation || "") + " ",
        h("strong", null, [reste || deux(min) + ":00"]),
      ]);
    }

    function entete(v) {
      return h("header", { class: "wp-tete wp-anime", style: "--i:0", cle: "tete" }, [
        h("p", { class: "wp-tete__titre" }, [
          (T.titre || "") + " ",
          h("span", { class: "wh-accent" }, [T.titreAccent || ""]),
          " ",
          v.nb ? h("span", { class: "wp-tete__nb", cle: "nb" }, [v.nb]) : null,
        ]),
        h("button", { type: "button", class: "wp-fermer", "aria-label": "Fermer le panier", act: fermer }, [icone("fermer")]),
      ]);
    }

    function confirmation(v) {
      if (!ajoute) return null;
      var l = null;
      v.lignes.forEach(function (x) {
        if (x.cle === ajoute.cle) l = x;
      });
      if (!l) return null;
      return h("p", { class: "wp-confirmation", role: "status", cle: "conf" + ajoute.t }, [
        h("span", { class: "wp-confirmation__icone" }, [icone("coche")]),
        l.nom + " " + (T.confirmation || ""),
      ]);
    }

    function corps(v) {
      var duo = v.duo;
      return h("div", { class: "wp-corps", cle: "corps" }, [
        h("div", { class: "wp-paliers wp-anime", style: "--i:1", cle: "paliers" }, [
          h("p", { class: duo ? "wp-paliers__message is-gagne" : "wp-paliers__message" }, [v.message || ""]),
          h("div", { class: "wp-paliers__piste" }, [
            h("span", { class: "wp-paliers__remplissage", style: "width:" + (duo ? "100%" : "50%") }),
            h("span", { class: "wp-palier is-gagne", style: "left:50%" }, [icone("colis")]),
            h("span", { class: duo ? "wp-palier is-gagne" : "wp-palier", style: "left:100%" }, [icone("cadeau")]),
          ]),
          h("div", { class: "wp-paliers__libelles" }, [
            h("span", { class: "is-gagne", style: "left:50%" }, [T.livraisonPalier || ""]),
            h("span", { class: duo ? "is-gagne" : null, style: "left:100%" }, [T.duo || ""]),
          ]),
        ]),
        h(
          "ul",
          { class: "wp-articles", cle: "articles" },
          v.lignes.map(function (l, i) {
            return article(l, i);
          })
        ),
        v.proposition
          ? h("div", { class: "wp-anime", style: "--i:" + (v.lignes.length + 2), cle: "offre" }, [carteProposition(v.proposition)])
          : null,
      ]);
    }

    function article(l, i) {
      var nouveau = ajoute && ajoute.cle === l.cle;
      return h(
        "li",
        { class: nouveau ? "wp-article wp-anime is-nouveau" : "wp-article wp-anime", style: "--i:" + (i + 2), cle: "l:" + l.cle },
        [
          h("a", { class: "wp-article__image", href: l.lien }, [h("img", { src: l.image, alt: "" })]),
          h("div", { class: "wp-article__infos" }, [
            h("a", { class: "wp-article__nom", href: l.lien }, [l.nom]),
            h("p", { class: "wp-article__variante" }, [l.variante]),
            h("div", { class: "wp-article__bas" }, [
              h("div", { class: "wp-quantite" }, [
                h(
                  "button",
                  { type: "button", "aria-label": "Retirer un exemplaire", act: function () { changer(l, l.quantite - 1); } },
                  [icone("moins")]
                ),
                h("span", { "aria-live": "polite" }, [l.quantite]),
                h(
                  "button",
                  { type: "button", "aria-label": "Ajouter un exemplaire", act: function () { changer(l, l.quantite + 1); } },
                  [icone("plus")]
                ),
              ]),
              h("p", { class: "wp-prix" }, [h("strong", null, [euros(l.prix)]), l.barre ? h("s", { cle: "barre" }, [euros(l.barre)]) : null]),
            ]),
          ]),
          h(
            "button",
            { type: "button", class: "wp-article__retirer", "aria-label": "Retirer " + l.nom, act: function () { changer(l, 0); } },
            [icone("corbeille")]
          ),
        ]
      );
    }

    function carteProposition(o) {
      var p = o.p;
      var n = choix.cle === p.cle ? Math.min(choix.i, o.coloris.length - 1) : 0;
      var c = o.coloris[n];
      var prix = p.remise ? c.prix - p.remise : c.prix;
      var barre = p.remise ? c.prix : c.barre;
      var pastilles = o.coloris.map(function (x, i) {
        return h("button", {
          type: "button",
          role: "radio",
          "aria-checked": String(n === i),
          "aria-label": x.coloris,
          title: x.coloris,
          class: n === i ? "wp-pastille is-actif" : "wp-pastille",
          style: "background:" + x.teinte,
          act: function () {
            choix = { cle: p.cle, i: i };
            rendre();
          },
        });
      });
      pastilles.push(h("span", { class: "wp-offre__coloris" }, [c.coloris]));
      return h("div", { class: "wp-offre", cle: "offre:" + p.cle }, [
        h("div", { class: "wp-offre__photo" }, [
          h("img", { src: p.photo, alt: "", loading: "lazy" }),
          h("span", { class: "wp-offre__remise" }, [p.etiquette]),
        ]),
        h("div", { class: "wp-offre__corps" }, [
          h("p", { class: "wp-offre__titre" }, [p.titre + " ", h("span", { class: "wh-accent" }, [p.accent])]),
          h("p", { class: "wp-offre__sous" }, [p.sous]),
          h("div", { class: "wp-offre__pastilles", role: "radiogroup", "aria-label": "Coloris" }, pastilles),
          h(
            "button",
            {
              type: "button",
              class: "wp-offre__ajouter",
              act: function () {
                ajouterProposition(p, c);
              },
            },
            [
              h("span", null, [T.ajouter || ""]),
              h("span", { class: "wp-offre__prix" }, [euros(prix) + " ", barre > prix ? h("s", null, [euros(barre)]) : null]),
            ]
          ),
        ]),
      ]);
    }

    function pied(v) {
      var totaux = [h("p", { cle: "livraison" }, [h("span", null, [T.livraison || ""]), h("span", { class: "wp-offerte" }, [T.offerte || ""])])];
      /* Remises de panier de Shopify (les remises par ligne sont déjà dans le prix des lignes). */
      v.remises.forEach(function (r, i) {
        totaux.push(
          h("p", { cle: "remise" + i }, [
            h("span", null, [r.title || r.code || ""]),
            h("span", { class: "wp-offerte" }, ["-" + euros(r.total_allocated_amount)]),
          ])
        );
      });
      totaux.push(h("p", { class: "wp-total", cle: "total" }, [h("span", null, [T.total || ""]), h("strong", null, [euros(v.total)])]));
      return h("footer", { class: "wp-pied wp-anime", style: "--i:" + (v.lignes.length + 3), cle: "pied" }, [
        v.economie > 0 ? h("p", { class: "wp-economie", cle: "economie" }, [(T.economie || "") + " ", h("strong", null, [euros(v.economie)])]) : null,
        h("div", { class: "wp-totaux", cle: "totaux" }, totaux),
        h("p", { class: "wp-klarna", cle: "klarna" }, [
          (T.klarnaAvant || "") + " 3 × " + euros(v.total / 3) + " " + (T.klarnaApres || ""),
          h("img", { src: D.klarna, alt: "Klarna", width: "45", height: "19" }),
        ]),
        h("a", { class: "wp-commander", href: route + "checkout", cle: "commander" }, [icone("cadenas"), (T.commander || "") + " · " + euros(v.total)]),
        h(
          "div",
          { class: "wp-paiements", cle: "paiements" },
          (D.paiements || []).map(function (m) {
            return h("img", { src: m.src, alt: m.nom, width: "34", height: "22", loading: "lazy" });
          })
        ),
        h("p", { class: "wp-garanties", cle: "garanties" }, [(T.garanties || []).filter(Boolean).join("  ·  ")]),
      ]);
    }

    /* -- Minuteur « panier réservé » : échéance gardée en cookie, relancée à l'échéance -- */
    function tic() {
      var maintenant = Date.now();
      if (!isFinite(echeance) || echeance <= maintenant) {
        echeance = maintenant + (Number(D.minutes) || 10) * 60000;
        document.cookie = "timerCart=" + echeance + "; Max-Age=86400; Path=/; SameSite=Lax";
      }
      var sec = Math.ceil((echeance - maintenant) / 1000);
      reste = deux(Math.floor(sec / 60)) + ":" + deux(sec % 60);
      var el = panneau.querySelector(".wp-reserve strong");
      if (el && el.textContent !== reste) el.textContent = reste;
    }
    function majMinuteur() {
      var actif = ouvert && vu && vu.nb > 0;
      if (actif && !minuteur) {
        echeance = 0;
        document.cookie.split("; ").forEach(function (c) {
          if (c.indexOf("timerCart=") === 0) echeance = Number(c.slice(10));
        });
        tic();
        minuteur = window.setInterval(tic, 1000);
      } else if (!actif && minuteur) {
        window.clearInterval(minuteur);
        minuteur = 0;
      }
    }

    /* -- Compte publié pour l'en-tête ----------------------------------------- */
    function publierCompte(nb) {
      if (nb === nbPublie) return;
      nbPublie = nb;
      window.Whoosh = window.Whoosh || {};
      window.Whoosh.panierCompte = nb;
      window.dispatchEvent(new CustomEvent("tpl-panier:compte", { detail: nb }));
    }

    /* -- Ouverture : page derrière figée (méthode Safari iPhone), Échap, focus -- */
    function surTouche(e) {
      if (e.key === "Escape") fermer();
    }
    function ouvrir() {
      if (ouvert) return;
      ouvert = true;
      racine.className = "wp is-ouvert";
      panneau.removeAttribute("inert");
      var html = document.documentElement;
      var body = document.body;
      html.classList.add("tpl-panier-ouvert");
      var y = window.scrollY;
      fige = {
        y: y,
        avant: { position: body.style.position, top: body.style.top, left: body.style.left, right: body.style.right, width: body.style.width },
      };
      window.dispatchEvent(new CustomEvent("tpl:fige", { detail: { actif: true, y: y } }));
      body.style.position = "fixed";
      body.style.top = "-" + y + "px";
      body.style.left = "0";
      body.style.right = "0";
      body.style.width = "100%";
      window.addEventListener("keydown", surTouche);
      window.setTimeout(function () {
        if (ouvert) panneau.focus({ preventScroll: true });
      }, 60);
      majMinuteur();
    }
    function fermer() {
      if (!ouvert) return;
      ouvert = false;
      racine.className = "wp";
      panneau.setAttribute("inert", "");
      window.removeEventListener("keydown", surTouche);
      document.documentElement.classList.remove("tpl-panier-ouvert");
      if (fige) {
        var s = document.body.style;
        s.position = fige.avant.position;
        s.top = fige.avant.top;
        s.left = fige.avant.left;
        s.right = fige.avant.right;
        s.width = fige.avant.width;
        window.scrollTo(0, fige.y);
        fige = null;
      }
      window.dispatchEvent(new CustomEvent("tpl:fige", { detail: { actif: false } }));
      majMinuteur();
    }

    /* -- Actions -------------------------------------------------------------- */
    /* La confirmation s'efface après quelques secondes. */
    function marquerAjout(cle) {
      ajoute = { cle: cle, t: Date.now() };
      window.clearTimeout(minuterieAjout);
      minuterieAjout = window.setTimeout(function () {
        ajoute = null;
        rendre();
      }, 3200);
    }

    function surAjouter(e) {
      var d = (e && e.detail) || {};
      var items = d.items;
      /* Compatibilité avec l'ancien détail de la maquette ({ slug }). */
      if (!items && d.slug && catalogue[d.slug]) items = [{ id: catalogue[d.slug].id, quantity: 1 }];
      if (!items || !items.length) {
        rendre();
        ouvrir();
        return;
      }
      items = items.map(function (it) {
        var x = { id: Number(it.id), quantity: Math.max(1, Number(it.quantity) || 1) };
        if (it.properties) x.properties = it.properties;
        return x;
      });
      memoriserPacks(items);
      enFile(function () {
        return requete("cart/add.js", { items: items })
          .then(function (rep) {
            var premier = (rep && rep.items && rep.items[0]) || (rep && rep.key ? rep : null);
            return charger().then(function () {
              if (premier) {
                var pid = premier.properties && premier.properties._pack_id;
                marquerAjout(pid ? "pack:" + pid : premier.key);
              }
            });
          })
          .catch(function (err) {
            if (window.console) console.warn("Panier Whoosh : ajout refusé", err);
            return charger();
          })
          .then(function () {
            nettoyerPacks();
            rendre();
            ouvrir();
          });
      });
    }

    function surOuvrir() {
      rendre();
      ouvrir();
      /* Le panier a pu changer dans un autre onglet : relecture discrète. */
      enFile(function () {
        return charger().then(rendre);
      });
    }

    function changer(l, quantite) {
      var q = Math.max(0, Math.min(MAX, quantite));
      if (q === l.quantite) return;
      optimiste[l.cle] = q;
      rendre();
      enFile(function () {
        var envoi;
        if (l.pack) {
          var maj = {};
          l.items.forEach(function (it) {
            maj[it.key] = q * (l.base[it.variant_id] || 1);
          });
          envoi = requete("cart/update.js", { updates: maj });
        } else {
          envoi = requete("cart/change.js", { id: l.cle, quantity: q });
        }
        return envoi
          .then(recevoir, function (err) {
            if (window.console) console.warn("Panier Whoosh : quantité refusée", err);
            return charger();
          })
          .then(function () {
            delete optimiste[l.cle];
            nettoyerPacks();
            rendre();
          });
      });
    }

    function ajouterProposition(p, c) {
      var item = { id: c.id, quantity: 1 };
      if (p.variante) item.properties = { _variante: p.variante };
      window.dispatchEvent(new CustomEvent("tpl-panier:ajouter", { detail: { items: [item] } }));
    }

    /* -- Branchements ---------------------------------------------------------- */
    function surClic(e) {
      var n = e.target;
      while (n && n !== racine) {
        if (n._act) {
          n._act(e);
          return;
        }
        n = n.parentNode;
      }
    }
    function surRetour(e) {
      /* Retour depuis la caisse (cache du navigateur) : relire le vrai panier. */
      if (e.persisted)
        enFile(function () {
          return charger().then(rendre);
        });
    }

    if (voile) voile._act = fermer;
    racine.addEventListener("click", surClic);
    window.addEventListener("tpl-panier:ajouter", surAjouter);
    window.addEventListener("tpl-panier:ouvrir", surOuvrir);
    window.addEventListener("pageshow", surRetour);

    rendre();
    enFile(function () {
      return charger().then(function () {
        nettoyerPacks();
        rendre();
      });
    });
    /* /cart renvoie vers l'accueil avec #panier : le tiroir s'ouvre. */
    function surAncre() {
      if (location.hash !== "#panier") return;
      try {
        history.replaceState(null, "", location.pathname + location.search);
      } catch (err) {}
      surOuvrir();
    }
    window.addEventListener("hashchange", surAncre);
    surAncre();

    return {
      ouvert: function () {
        return ouvert;
      },
      ouvrir: surOuvrir,
      fermer: fermer,
      detruire: function () {
        fermer();
        window.clearTimeout(minuterieAjout);
        racine.removeEventListener("click", surClic);
        window.removeEventListener("tpl-panier:ajouter", surAjouter);
        window.removeEventListener("tpl-panier:ouvrir", surOuvrir);
        window.removeEventListener("pageshow", surRetour);
        window.removeEventListener("hashchange", surAncre);
      },
    };
  }

  /* --- Initialisation, une fois par tiroir ; éditeur de thème ---------------------- */
  function initialiser(portee) {
    var donnees = portee.querySelector("script[data-wp-donnees]");
    var racine = portee.querySelector(".wp");
    if (!donnees || !racine || racine._wp) return null;
    var D;
    try {
      D = JSON.parse(donnees.textContent);
    } catch (e) {
      return null;
    }
    racine._wp = creer(racine, D);
    return racine._wp;
  }

  /* Sur DOMContentLoaded : l'en-tête écoute déjà `tpl-panier:compte` quand le tiroir publie. */
  function demarrer() {
    initialiser(document);
  }
  if (document.readyState === "complete") demarrer();
  else {
    document.addEventListener("DOMContentLoaded", demarrer);
    window.addEventListener("load", demarrer);
  }

  var etaitOuvert = false;
  function tiroirDe(e) {
    var r = e.target && e.target.querySelector && e.target.querySelector(".wp");
    return r && r._wp ? r : null;
  }
  document.addEventListener("shopify:section:unload", function (e) {
    var r = tiroirDe(e);
    if (!r) return;
    etaitOuvert = r._wp.ouvert();
    r._wp.detruire();
    r._wp = null;
  });
  document.addEventListener("shopify:section:load", function (e) {
    var t = initialiser(e.target);
    if (t && etaitOuvert) t.ouvrir();
    etaitOuvert = false;
  });
  /* Dans l'éditeur, sélectionner la section ouvre le tiroir. */
  document.addEventListener("shopify:section:select", function (e) {
    var r = tiroirDe(e);
    if (r) r._wp.ouvrir();
  });
  document.addEventListener("shopify:section:deselect", function (e) {
    var r = tiroirDe(e);
    if (r) r._wp.fermer();
  });
})();
